<template>
    <div>
        <h1 itemprop="name">
            {{ product.name }}

            <h5>
                <span v-if="product.special_offer === 1" class="label label-primary">Special Offer</span>

                <span v-if="product.heavy === 1" class="label label-primary">
                    Heavy Item
                </span>

                <span v-if="product.recommended === 1" class="label label-primary">
                    Recommended Product
                </span>
            </h5>
        </h1>
        <div class="row">
            <div class="col-xs-12 col-md-5 col-lg-5">
                <div class="panel panel-default product-image-lg">
                    <div class="panel-body">
                        <img :src="photo" :title="product.full_name" class="img-responsive" :alt="product.full_name"/>
                    </div>
                    <div class="panel-footer">
                        <div v-if="help.length > 0">
                            <h3>Help Files</h3>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="item in help" :title="item.name">
                                    <a :href="'/help-resources/' + item.filename + '.pdf'" target="_blank"><i
                                            class="fa fa-file"/> {{item.name}}</a>
                                </li>
                            </ul>
                        </div>
                        <kit-list v-if="kit" :kit="kit"/>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-7 col-lg-7">
                <table v-if="hasChildren" class="table table-hover options-list">
                    <thead>
                    <tr>
                        <th>Option</th>
                        <th>Price</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <product-child v-for="child in product.children" :child="child" :key="child.id"/>
                    </tbody>
                </table>
                <span v-else>
                        <strong>{{product.name}} at £{{product.price}}</strong>
                        <input v-model="quantity" type="number" class="form-control" name="quantity">
                        <button class="btn btn-primary" @click.prevent="addToCart">
                            <i class="fa fa-plus"/> | Add to cart
                        </button>
                    </span>
                <span itemprop="description" v-html="product.description"/>
                <span>
                        <kit-list v-if="!hasChildren && hasKit" :kit="product.kit"/>

                        <p class="weeks-ec text-center">{{product.weeks}}  {{product.ec}}</p>
                    </span>
                <div class="loadedInfo">
                    <div v-if="hasChildren" v-for="child in product.children">
                        <div itemprop="offers" itemscope itemtype="http://schema.org/Offer" style="display:none;">
                            <span itemprop="name">
                                {{ child.fullName }}
                            </span>
                            <span itemprop="description" v-html="product.description"/>

                            <span itemprop="price">
                                £{{child.price}}
                            </span>

                            <span itemprop="url">
                                URL
                            </span>
                        </div>
                    </div>
                    <div v-else>
                        <div itemprop="offers" itemscope itemtype="http://schema.org/Offer" style="display:none;">
                            <span itemprop="name">
                                {{ product.fullName }}
                            </span>

                            <span itemprop="description" v-html="product.description"/>

                            <span itemprop="price">
                                {{product.price}}
                            </span>

                            <span itemprop="url">
                                URL
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Child from './detail-child.vue';
    import Kit from './kitlist.vue';
    import { getProductHelp } from "../../../api/products/product-help";
    import { getProduct } from "../../../api/products/products";

    export default {
        data() {
            return {
                product: {
                    children: {}
                },

                help: [],

                quantity: 1

            }
        },

        components: {
            'product-child' : Child,
            'kit-list' : Kit
        },

        methods: {
            addButton( button, data = null ) {
                if ( !data ) {
                    button.className += " disabled";
                    button.innerHTML = '<i class="fa fa-spin fa-spinner"></i> Adding';
                } else {
                    if ( data.error ) {
                        button.className = 'btn btn-danger'

                    } else {
                        button.className = button.className.replace( new RegExp( '(?:^|\\s)' + 'disabled' + '(?:\\s|$)' ), ' ' );
                    }
                    button.innerHTML = data.text;
                }
            },

            addToCart() {
                let button = event.currentTarget;
                let item = {};
                this.addButton( button );
                this.$store.dispatch( 'addItemToCart', this.item ).then(
                    ( cart ) => {
                        this.addButton( button, { text: '<i class="fa fa-plus"></i> | Add to cart' } )
                    },
                    ( error ) => {
                        this.addButton( button, { text: 'Error adding item', error: error } );
                    }
                );
            },

            getProduct() {
                getProduct( this.$route.params.productSlug )
                    .then(
                        ( response ) => {
                            this.product = response.data;
                            this.getHelp();
                        }, ( error ) => {
                            console.log( error );
                        }
                    );
            },

            getHelp() {
                getProductHelp(this.$route.params.productSlug)
                    .then( (response) => {
                        this.help = response.data;
                    })
                    .catch( (error) => {
                        console.log(error);
                    });
            },

            back() {
                this.$router.go(-1);
            }
        },

        computed: {
            item() {
                return {
                    product_id: this.product.id,
                    quantity: this.quantity,
                    cost: this.product.price
                }
            },

            hasChildren() {
                return (this.product.children.length > 0);
            },

            hasKit() {
                return this.product.kit && this.product.kit > 0;
            },

            kit() {
                return this.$store.getters.kitList;
            },

            photo() {
                let path = '/storage/products/';
                if ( this.product.photo !== "" ) {
                    return path + this.product.photo;
                } else {
                    return path + '../default-product.png';
                }
            }
        },

        beforeRouteEnter: (to, from, next) => {
            next( vm => {
                vm.getProduct();
            });
        },

        beforeRouteLeave (to, from, next) {
            this.$store.commit('kitList', false);
            next();
        }
    }
</script>